import { type AxiosResponse } from 'axios'
import { usersAuthorizedFetch } from '../../app/axios/logikspark'
import { IBranding } from './types'

export const getBranding = async (tenantId: number): Promise<AxiosResponse<any, any>> => {
  return await usersAuthorizedFetch.get('/get-branding-by-tenant-id', { params: { tenantId } })
}

export const getOnBoarding = async (tenantId: number): Promise<AxiosResponse<any, any>> => {
  return await usersAuthorizedFetch.get('/onboard', { params: { tenantId } })
}

export const postBranding = async (branding: IBranding): Promise<AxiosResponse<any, any>> => {
  return await usersAuthorizedFetch.post('/create-branding', branding)
}

export const updateBranding = async (branding: IBranding): Promise<AxiosResponse<any, any>> => {
  return await usersAuthorizedFetch.put('/update-branding', branding)
}

// E8 8.1.3 / WI 565 — multipart logo upload. Content-Type is cleared so axios derives
// `multipart/form-data; boundary=...` from the FormData (the instance default is application/json, which
// would break the server's multipart parse). The bearer is still attached by the request interceptor.
export const uploadTenantLogo = async (tenantId: number, file: File): Promise<AxiosResponse<any, any>> => {
  const formData = new FormData()
  formData.append('file', file)
  return await usersAuthorizedFetch.post(`/tenant/${tenantId}/branding/logo`, formData, {
    headers: { 'Content-Type': null },
  })
}
